import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../common/withRouter';
import {
  SimpleDataTable as DataTable,
  Loader,
  ButtonOBSOLETED,
  Notification,
  Message
} from '../../web.common';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import withApi from '../higherOrderComponents/withApi';
import { Filters, FilterInput, FilterSelect, FilterSelectAsync } from './Filters';
import { getQueryStringParameters } from '../../common/utils';
import {
  DisplayDate,
  DisplayGuid,
  DisplayType
} from '../items';

const resultsCount = 15;

class IntegrationsInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: false };
  }

  goToPage(number) {
    // TODO consider to move responsability to filter component
    const { history, location } = this.props;
    const filters = Object.assign(
      {},
      getQueryStringParameters(location.search),
      {
        page: number
      });
    const search = Object.keys(filters)
      .filter(key => key && filters[key])
      .map(key => `${key}=${encodeURIComponent(filters[key])}`).join('&');
    history.push(`?${search}`);
  }

  async loadData(filters, skipPages) {
    const { props: { api: { integrations: { searchIntegrations } } } } = this;

    this.setState({ isLoading: true });
    let result = null;

    try {
      result = await searchIntegrations({ filters, skipPages, resultsCount });
    }
    catch (e) {
      console.error(`unable to load. ${e}`);
      this.setState({ isLoading: false, errorMessage: new Message('error', 'Unable to load data') });

      return;
    }

    this.setState({ isLoading: false });

    return result;
  }

  render() {
    const { history, location, systemTypes } = this.props;
    const { isLoading, errorMessage } = this.state;
    const parameters = getQueryStringParameters(location.search);
    const pageNumber = parameters.page ? parseInt(parameters.page, 10) : 1;

    const { api: { facilities: { lookupByNameOrId: lookupFacility } } } = this.props;

    const mappedSystemTypes = systemTypes.map(({ Name }) => ({ value: Name, label: Name }));

    return (
      <LayoutContext.Consumer>
        {() => (
          <React.Fragment>
            <Notification newMessage={errorMessage} />
            <PageTop
              documentTitle='Integrations list'
              documentDescription='Integrations list'
            />
            <h2 className='main-page-header'>
              Integrations
            </h2>
            <Filters
              initFromUrl
              submitUrl
              validateForm={({
                integrationId,
                productId,
                systemType,
                facilityId
              }, updatedKey) => {
                if (updatedKey !== 'integrationId') {
                  return {
                    productId,
                    systemType,
                    facilityId
                  };
                }
                return { integrationId };
              }}
              render={(formData, update) => (
                <div className='filters-block'>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='integrationId'>
                      Id
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name='integrationId'
                      placeholder='Find by id'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='productId'>
                      Product Id
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name='productId'
                      placeholder='Filter by product id'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='systemType'>
                      System Type
                    </label>
                    <FilterSelect
                      className='filter-select'
                      data={formData}
                      update={update}
                      name='systemType'
                      options={mappedSystemTypes}
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='facilityId'>
                      Facility
                    </label>
                    <FilterSelectAsync
                      className='filter-select'
                      data={formData}
                      debounce
                      update={update}
                      name='facilityId'
                      loadOptions={async inputValue => lookupFacility(inputValue)}
                    />
                  </div>
                  <br />
                  <br />
                  <div className='filters-submit-wrapper'>
                    <ButtonOBSOLETED type='submit' buttonContent='Search' disabled={isLoading} />
                  </div>
                  <hr />
                </div>
              )}
            />
            <DataTable
              style={{ marginTop: '100px' }}
              loadingContent={(<Loader hasLoaded={false} />)}
              tableConfig={{
                tableName: 'integrations',
                rowClasses: 'hover-listview',
                rowClick: ({ ProductId }) => {
                  history.push(`/product/${ProductId}/integration`);
                },
                columns: [
                  {
                    property: 'Id',
                    label: 'Id',
                    render: ({ Id }) => <DisplayGuid>{Id}</DisplayGuid>
                  }, {
                    property: 'ProductName',
                    label: 'ProductName',
                    type: 'string'
                  }, {
                    property: 'FacilityName',
                    label: 'FacilityName',
                    type: 'string'
                  }, {
                    property: 'SystemType',
                    label: 'SystemType',
                    render: ({ SystemType }) => <DisplayType>{SystemType}</DisplayType>
                  }, {
                    property: 'CreatedAt',
                    label: 'CreatedAt',
                    render: ({ CreatedAt }) => <DisplayDate>{CreatedAt}</DisplayDate>
                  }
                ]
              }}
              getData={async newPageNumber => {
                const filters = getQueryStringParameters(location.search);
                return this.loadData(filters, newPageNumber || 1);
              }}
              paginationData={{
                renderLocation: 'both',
                rowsPerPage: resultsCount,
                pageNumber,
                goToPageNumber: number => this.goToPage(number)
              }}
              skipTableNoResults
              cellVerticalAlign='top'
              hideTableHead={false}
              languageCode='en'
              labels={{
                tableBody: {
                  noResult: <div style={{ display: 'block', textAlign: 'center' }}>No Results</div>
                }
              }}
              cellContent='cellContent'
            />
          </React.Fragment>
        )}
      </LayoutContext.Consumer>
    );
  }
}

const Integrations = withRouter(withApi(
  connect(({ user, systemTypes }) => ({ isLoggedIn: !!user, systemTypes }), {})(IntegrationsInternal)
));

Integrations.requiresLogin = true;
Integrations.propTypes = { isLoggedIn: PropTypes.bool };

export default Integrations;